import { useEffect, useState } from 'react';
import { AbstractProgress } from 'foundations-components/transitional/components/AbstractProgress';
import { NanoProgress } from 'foundations-components/transitional/components/NanoProgress';
import { useGridList } from './useGridList';
import { jsx as _jsx } from "react/jsx-runtime";
const PROGRESS_ANIMATION_COMPLETION_DELAY = 100;

/**
 * GridListRefreshProgress
 *
 * @description A grid list component that exposes a small, animating progress bar
 * when the GridList is passed isRefreshing=true.
 *
 * It keys off the isRefreshing prop. It encapsulates the logic when isRefreshing transitions
 * from true to false. When this occurs it will animate the progress bar to 100% before hiding
 * it after 100ms.
 */
export function GridListRefreshProgress() {
  const {
    isRefreshing
  } = useGridList();
  const [isAnimatingRefresh, setIsAnimatingRefresh] = useState(false);
  const [refreshValue, setRefreshValue] = useState(0);
  useEffect(() => {
    if (isRefreshing) {
      return setIsAnimatingRefresh(true);
    } else if (!isAnimatingRefresh && !isRefreshing) {
      return;
    }
    setRefreshValue(100);
    const refreshAnimationTimeout = setTimeout(() => {
      setIsAnimatingRefresh(false);
    }, PROGRESS_ANIMATION_COMPLETION_DELAY);
    return () => clearTimeout(refreshAnimationTimeout);
  }, [isAnimatingRefresh, isRefreshing, refreshValue]);
  function handleAnimatingRefreshChange(value) {
    setRefreshValue(value);
  }
  if (!isAnimatingRefresh) {
    return null;
  }
  return /*#__PURE__*/_jsx(AbstractProgress, {
    completionLingerTime: 1,
    incrementFactor: 0.1,
    maximum: 100,
    render: ({
      value
    }) => {
      // Adding an event emitter to the render prop is pretty hacky, but without access
      // the underlying hooks of the AbstractProgress component, this is the best way to
      // be able to control the unmounting of the progress bar.
      //
      // In the future it likely makes sense for this to be builtin functionality to
      // AbstractProgress, but right now we can maintain a bit of a hack.
      handleAnimatingRefreshChange(value);
      return /*#__PURE__*/_jsx(NanoProgress, {
        value: isAnimatingRefresh ? refreshValue : 100
      });
    }
  });
}